import { createContext } from "react";

const componentContext = createContext();

export default componentContext;
